module.exports = __webpack_public_path__ + "img/collect-reward.cecc76cd.png";